export default function Requests() {
  return <div className="animate-fade-in"><h1 className="text-3xl font-bold">Requests</h1></div>
}
